/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	let isInitialized = false;
	let resizeTimer = null;
	let intersectionObserver = null;

	const mvSlider = () => {
		// 初期化と更新を分離
		if (!isInitialized) {
			initializeSliders();
		}
		
		// アニメーション設定の更新（軽量）
		updateSliderAnimation();
		
		// 処理完了後に.top-mvにis-activeクラスを追加
		const topMv = document.querySelector('.top-mv');
		if (topMv) {
			topMv.classList.add('is-active');
		}
	};

	// スライダーの初期化（DOM操作）
	const initializeSliders = () => {
		const sliders = document.querySelectorAll('.js_recruitSlider');
		
		sliders.forEach((slider, index) => {
			setupSliderElements(slider);
			observeSlider(slider);
		});
		
		isInitialized = true;
	};

	// スライダー要素の設定
	const setupSliderElements = (slider) => {
		// 既存のli要素を取得
		const originalItems = slider.querySelectorAll('li');
		
		// 無限スクロール用の複製（4倍にする）
		cloneSliderItems(originalItems, slider);
		
		// 表示状態にする
		slider.classList.remove('vis_hide');
	};

	// スライダー要素の複製
	const cloneSliderItems = (originalItems, slider) => {
		for (let i = 0; i < 3; i++) {
			originalItems.forEach(item => {
				const clonedItem = item.cloneNode(true);
				slider.appendChild(clonedItem);
			});
		}
	};

	// Intersection Observerでスライダーの可視性を監視
	const observeSlider = (slider) => {
		if (!intersectionObserver) {
			createIntersectionObserver();
		}
		intersectionObserver.observe(slider);
	};

	// Intersection Observerの作成
	const createIntersectionObserver = () => {
		intersectionObserver = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				const slider = entry.target;
				handleSliderVisibility(slider, entry.isIntersecting);
			});
		}, {
			// 少し余裕を持って判定（画面の10%でも見えていれば実行）
			rootMargin: '10% 0px',
			threshold: 0.1
		});
	};

	// スライダーの可視性変更処理
	const handleSliderVisibility = (slider, isVisible) => {
		if (isVisible) {
			// 画面内に入ったらアニメーション再開
			slider.classList.add('is-visible');
			if (slider.dataset.animationReady === 'true') {
				slider.classList.add('is-animating');
			}
		} else {
			// 画面外に出たらアニメーション停止
			slider.classList.remove('is-visible', 'is-animating');
		}
	};

	const updateSliderAnimation = () => {
		const sliders = document.querySelectorAll('.js_recruitSlider');
		
		sliders.forEach((slider, index) => {
			setupSliderAnimation(slider, index);
		});
	};

	// 個別のスライダーアニメーション設定
	const setupSliderAnimation = (slider, index) => {
		// 一時的にアニメーションを停止
		slider.classList.remove('is-animating');
		
		const animationConfig = calculateAnimationConfig(slider);
		const animDistance = calculateAnimationDistance(animationConfig);
		
		// CSSカスタムプロパティで値を更新
		slider.style.setProperty('--slide-distance', `${animDistance}px`);
		
		// アニメーションの準備完了をマーク
		slider.dataset.animationReady = 'true';
		
		// 画面内にある場合のみアニメーション開始
		startAnimationIfVisible(slider);
	};

	// アニメーション設定値の計算
	const calculateAnimationConfig = (slider) => {
		const originalCount = slider.querySelectorAll('li').length / 4; // 4倍複製後
		const isMobile = window.matchMedia('(max-width: 768px)').matches;
		
		return {
			originalCount,
			slideWidth: isMobile ? 150 : 420,
			slideMargin: isMobile ? 15 : 56,
			isReverse: slider.classList.contains('_reverse'),
			totalElements: slider.querySelectorAll('li').length
		};
	};

	// アニメーション距離の計算
	const calculateAnimationDistance = (config) => {
		// DOM構造: [1][2][3][4][5][1][2][3][4][5][1][2][3][4][5][1][2][3][4][5] (20個)
		// 11個目の位置（3セット目の1個目） = 1個目の位置 → 10個分のスライド + 10個分の余白を移動
		const slidesToMove = config.originalCount * 2; // 10個
		return config.slideWidth * slidesToMove + config.slideMargin * slidesToMove;
	};

	// 可視状態の場合アニメーション開始
	const startAnimationIfVisible = (slider) => {
		setTimeout(() => {
			if (slider.classList.contains('is-visible')) {
				slider.classList.add('is-animating');
			}
		}, 50);
	};

	// デバウンス付きリサイズハンドラ
	const handleResize = () => {
		if (resizeTimer) clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			// リサイズ時はアニメーション設定のみ更新（初期化は不要）
			updateSliderAnimation();
		}, 100);
	};

	const h2anim = () => {
		// アニメーション設定
		const animConfig = {
			charInterval: 0.03,      // 文字間の間隔（秒）
			transitionDuration: 0.4, // 各文字のフェード時間（秒）
			subToMainDelay: 0.2      // 英語から日本語への遅延時間（秒）
		};
		
		// .mod-comboHeadと.mod-titleSetの両方を対象にする
		const targets = document.querySelectorAll('.js-anim .mod-comboHead, .js-anim .mod-titleSet');
		
		targets.forEach(target => {
			// データ属性に設定を保存
			target.dataset.animConfig = JSON.stringify(animConfig);
			
			// 英語テキスト（__sub）の処理
			const subSpan = target.querySelector('.__sub span');
			if (subSpan) {
				wrapCharacters(subSpan, 'sub', animConfig);
			}
			
			// 日本語テキスト（__main）の処理
			const mainSpan = target.querySelector('.__main span');
			if (mainSpan) {
				wrapCharacters(mainSpan, 'main', animConfig);
			}
		});
	};

	// 文字を1文字ずつspanで囲む関数
	const wrapCharacters = (element, type, config) => {
		const text = element.textContent;
		const chars = text.split('');
		element.innerHTML = '';
		
		chars.forEach((char, index) => {
			const span = document.createElement('span');
			span.textContent = char === ' ' ? '\u00A0' : char; // スペースは&nbsp;に変換
			span.style.opacity = '0';
			span.style.transition = `opacity ${config.transitionDuration}s ease ${index * config.charInterval}s`;
			span.classList.add(`char-anim-${type}`);
			element.appendChild(span);
		});
	};

	// .js-animにis-activeが追加されたときのアニメーション開始
	const startCharAnimation = () => {
		// MutationObserverで.js-animのクラス変化を監視
		const parentTargets = document.querySelectorAll('.js-anim');
		
		parentTargets.forEach(parentTarget => {
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
						if (parentTarget.classList.contains('is-active')) {
							// 親要素内の.mod-comboHeadまたは.mod-titleSetを取得してアニメーション実行
							const comboHead = parentTarget.querySelector('.mod-comboHead');
							const titleSet = parentTarget.querySelector('.mod-titleSet');
							
							if (comboHead) {
								animateChars(comboHead);
							}
							if (titleSet) {
								animateChars(titleSet);
							}
							observer.disconnect(); // 一度実行したら監視を停止
						}
					}
				});
			});
			
			observer.observe(parentTarget, {
				attributes: true,
				attributeFilter: ['class']
			});
		});
	};

	// 文字アニメーションの実行
	const animateChars = (target) => {
		// 設定を取得
		const config = JSON.parse(target.dataset.animConfig);
		const subChars = target.querySelectorAll('.char-anim-sub');
		const mainChars = target.querySelectorAll('.char-anim-main');
		
		// 英語テキストのアニメーション（先に実行）
		subChars.forEach((char) => {
			char.style.opacity = '1';
		});
		
		// 日本語テキストのアニメーション（英語開始からの遅延）
		const mainStartDelay = config.subToMainDelay; // 英語開始を基準とした日本語開始遅延
		
		mainChars.forEach((char, index) => {
			setTimeout(() => {
				char.style.opacity = '1';
			}, (mainStartDelay + index * config.charInterval) * 1000);
		});
	};
	// メイン実行関数
	const initializeRecruitSliders = () => {
		mvSlider();
		h2anim();
		startCharAnimation();
		initLocalNav();
		initMvSlides();
		window.addEventListener('resize', handleResize);
	};

	// js-recMvSlidesの初期化
	const initMvSlides = () => {
		const mvSlides = document.querySelectorAll('.js-recMvSlides');
		
		if (mvSlides.length === 0) return;
		
		mvSlides.forEach((slide) => {
			const isReverse = slide.classList.contains('_reverse');
			
			new Splide(slide, {
				type: 'loop',
				drag: false,
				focus: 'center',
				perPage: 'auto',
				autoScroll: {
					speed: isReverse ? -1 : 1,
					pauseOnHover: false,
					pauseOnFocus: false,
				},
				arrows: false,
				pagination: false,
				autoWidth: true,
				gap: '56px',
				breakpoints: {
					768: {
						gap: '15px',
					}
				}
			}).mount(window.splide.Extensions);
		});
	};

	// ローカルナビゲーションの初期化
	const initLocalNav = () => {
		const navButtons = document.querySelectorAll('.recruit-localNav > ul > li > button');
		const isMobile = () => window.matchMedia('(max-width: 1024px)').matches;
		
		navButtons.forEach(button => {
			const parentLi = button.parentElement;
			const subMenu = button.nextElementSibling;
			
			// サブメニューがない場合はスキップ
			if (!subMenu || subMenu.tagName !== 'UL') return;
			
			// PC: ホバー時（常に設定し、実行時にモバイル判定）
			parentLi.addEventListener('mouseenter', () => {
				if (!isMobile()) {
					activateNavItem(button, subMenu);
				}
			});
			
			parentLi.addEventListener('mouseleave', () => {
				if (!isMobile()) {
					deactivateNavItem(button, subMenu);
				}
			});
			
			// フォーカス時（タブキー対応）
			button.addEventListener('focus', () => {
				if (!isMobile()) {
					activateNavItem(button, subMenu);
				}
			});
			
			// フォーカスアウト時（サブメニュー外にフォーカスが移動した場合）
			button.addEventListener('blur', (e) => {
				if (!isMobile()) {
					// フォーカスがサブメニュー内のリンクに移動していない場合のみ閉じる
					setTimeout(() => {
						if (!parentLi.contains(document.activeElement)) {
							deactivateNavItem(button, subMenu);
						}
					}, 0);
				}
			});
			
			// サブメニュー内のリンクからフォーカスが外れた時
			if (subMenu) {
				const subLinks = subMenu.querySelectorAll('a');
				subLinks.forEach((link, index) => {
					link.addEventListener('blur', (e) => {
						if (!isMobile()) {
							setTimeout(() => {
								if (!parentLi.contains(document.activeElement)) {
									deactivateNavItem(button, subMenu);
								}
							}, 0);
						}
					});
				});
			}
			
			// タブレット以下: クリック時
			button.addEventListener('click', (e) => {
				if (isMobile()) {
					e.preventDefault();
					
					// 既にアクティブなら閉じる、そうでなければ開く
					if (button.classList.contains(a)) {
						deactivateNavItem(button, subMenu);
					} else {
						// 他のアクティブなアイテムを閉じる
						navButtons.forEach(otherButton => {
							if (otherButton !== button && otherButton.classList.contains(a)) {
								const otherSubMenu = otherButton.nextElementSibling;
								deactivateNavItem(otherButton, otherSubMenu);
							}
						});
						
						activateNavItem(button, subMenu);
					}
				}
			});
		});
		
		// タブレット以下: recruit-localNav外をタップしたら開いているメニューを閉じる
		const localNav = document.querySelector('.recruit-localNav');
		if (localNav) {
			document.addEventListener('click', (e) => {
				if (isMobile()) {
					// クリックされた要素がrecruit-localNav内でない場合
					if (!localNav.contains(e.target)) {
						// 全てのアクティブなメニューを閉じる
						navButtons.forEach(button => {
							if (button.classList.contains(a)) {
								const subMenu = button.nextElementSibling;
								deactivateNavItem(button, subMenu);
							}
						});
					}
				}
			});
		}
		
		// リサイズ時の処理
		let navResizeTimer;
		window.addEventListener('resize', () => {
			clearTimeout(navResizeTimer);
			navResizeTimer = setTimeout(() => {
				// リサイズ後、全てのアクティブ状態をクリア
				navButtons.forEach(button => {
					const subMenu = button.nextElementSibling;
					if (button.classList.contains(a)) {
						deactivateNavItem(button, subMenu, true); // アニメーションなしで即座に閉じる
					}
				});
			}, 100);
		});
	};
	
	// ナビアイテムをアクティブにする
	const activateNavItem = (button, subMenu) => {
		if (!subMenu) return;
		
		button.classList.add(a);
		
		// 初期状態を設定
		subMenu.style.display = 'block';
		subMenu.style.visibility = 'visible';
		subMenu.style.pointerEvents = 'auto';
		subMenu.style.height = '0';
		subMenu.style.overflow = 'hidden';
		subMenu.style.transform = 'translateY(-10px)';
		subMenu.style.transition = 'height 0.3s ease, transform 0.3s ease';
		
		// 実際の高さを取得
		const height = subMenu.scrollHeight;
		
		// アニメーション開始直前にopacityを1に設定
		requestAnimationFrame(() => {
			subMenu.style.opacity = '1';
			
			// アニメーション開始（次のフレームで実行）
			requestAnimationFrame(() => {
				subMenu.style.height = `${height}px`;
				subMenu.style.transform = 'translateY(0)';
			});
		});
		
		// アニメーション終了後に高さをautoに戻す
		setTimeout(() => {
			if (button.classList.contains(a)) {
				subMenu.style.height = 'auto';
				subMenu.style.overflow = '';
			}
		}, 300);
	};
	
	// ナビアイテムを非アクティブにする
	const deactivateNavItem = (button, subMenu, immediate = false) => {
		if (!subMenu) return;
		
		button.classList.remove(a);
		
		if (immediate) {
			// 即座に閉じる（リサイズ時）
			subMenu.style.display = 'none';
			subMenu.style.visibility = '';
			subMenu.style.pointerEvents = '';
			subMenu.style.height = '';
			subMenu.style.opacity = '';
			subMenu.style.transform = '';
			subMenu.style.overflow = '';
			subMenu.style.transition = '';
			return;
		}
		
		// 現在の高さを取得して固定
		const height = subMenu.offsetHeight;
		subMenu.style.height = `${height}px`;
		subMenu.style.overflow = 'hidden';
		subMenu.style.transition = 'height 0.3s ease, transform 0.3s ease';
		
		// アニメーション開始
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				subMenu.style.height = '0';
				subMenu.style.transform = 'translateY(-10px)';
			});
		});
		
		// アニメーション終了後にopacityを0にし、その他の設定をリセット
		setTimeout(() => {
			if (!button.classList.contains(a)) {
				subMenu.style.opacity = '0';
				subMenu.style.display = 'none';
				subMenu.style.visibility = '';
				subMenu.style.pointerEvents = '';
				subMenu.style.height = '';
				subMenu.style.transform = '';
				subMenu.style.overflow = '';
				subMenu.style.transition = '';
			}
		}, 300);
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const recruitUNCTIONS = () => {
		initializeRecruitSliders();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { recruitUNCTIONS(); }) : recruitUNCTIONS();

})(window.FUNCTIONS);
